import { render, staticRenderFns } from "./bookshelfPage.vue?vue&type=template&id=5c130108&scoped=true"
import script from "./bookshelfPage.vue?vue&type=script&lang=js"
export * from "./bookshelfPage.vue?vue&type=script&lang=js"
import style0 from "./bookshelfPage.vue?vue&type=style&index=0&id=5c130108&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c130108",
  null
  
)

export default component.exports